export default function FreeDomainBanner() {
    const scrollToPricing = () => {
        const pricingSection = document.getElementById('pricing-section');
        if (pricingSection) {
            pricingSection.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
    
    return (
        <section className="relative w-full py-10 md:py-8 lg:py-5 bg-gradient-to-r from-purple-900/30 to-blue-900/30 border-y border-purple-500/20">
            <div className="container">
                <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-between gap-4 lg:gap-8">
                    <div className="flex flex-col sm:flex-row items-center gap-3 lg:gap-4 text-center lg:text-left">
                        <span className="px-4 py-1.5 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-xs font-bold rounded-full uppercase tracking-wider">
                            Free Domain Included
                        </span>
                        <p className="text-white text-lg font-medium">
                            Enjoy a free domain when you choose an annual Website Builder plan
                        </p>
                    </div>

                    <button
                        onClick={scrollToPricing}
                        className="px-6 lg:px-8 py-2.5 lg:py-3 bg-white text-black text-sm lg:text-base font-semibold rounded-lg hover:bg-gray-200 transition-colors whitespace-nowrap"
                    >
                        View Plans & Pricing
                    </button>
                </div>
            </div>
        </section>
    );
}